import React from "react";
import { Box, Typography, List, ListItem, ListItemText, ListItemButton, Chip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

export default function BrandRatingsList({ ratings, isLoading }) {
  const navigate = useNavigate();
  const { id: brandId } = useParams();

  if (isLoading) {
    return <Typography variant="body2">Loading ratings...</Typography>;
  }

  if (!ratings || ratings.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No brand ratings yet.
      </Typography>
    );
  }

  const handleRatingClick = (ratingId) => {
    navigate(`/brands/${brandId}/ratings/${ratingId}`);
  };

  return (
    <List dense>
      {ratings.map((rating) => (
        <ListItem key={rating.id} divider disablePadding>
          <ListItemButton onClick={() => handleRatingClick(rating.id)}>
            <ListItemText
              primary={
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {rating.rawScore && (
                    <Chip
                      label={`Raw Score: ${rating.rawScore}`}
                      variant="outlined"
                      size="small"
                      color="primary"
                    />
                  )}
                  {rating.sectionScores && rating.sectionScores.map((sectionScore, index) => (
                    <Chip
                      key={index}
                      label={`${sectionScore.section}: ${sectionScore.score}`}
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: "0.8rem", height: "26px" }}
                    />
                  ))}
                </Box>
              }
              secondary={
                <Box>
                  <Typography variant="caption" display="block">
                    Rubric: {rating.rubric?.category || "Unknown"}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Created: {new Date(rating.createdAt).toLocaleDateString()}
                  </Typography>
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
